import { z } from "zod";

export const leiNumberValidation = z
  .string()
  .min(1, { message: "validation:leiNumberRequired" })
  .superRefine((val, ctx) => {
    if (!/^[a-zA-Z0-9]*$/.test(val)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "validation:leiNumberAlphanumeric",
      });
    } else if (val.length < 20) {
      ctx.addIssue({
        code: z.ZodIssueCode.too_small,
        type: "string",
        minimum: 20,
        inclusive: true,
        message: "validation:leiNumberLength",
      });
    }
  });

export const eoriNumberValidation = z
  .string()
  .min(1, { message: "validation:eoriNumberRequired" })
  .regex(/^[A-Z]{2}[A-Z0-9]+$/i, { message: "validation:eoriNumberFormat" })
  .nullable();
